// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LoadingAnimation_loadingContainer__fLnIu {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 32px 24px;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  border-radius: 16px;
  border: 2px solid rgba(59, 130, 246, 0.1);
  box-shadow: 0 8px 32px rgba(59, 130, 246, 0.1), 0 2px 8px rgba(0, 0, 0, 0.05);
  margin: 16px 0;
  position: relative;
  overflow: hidden;
  opacity: 1;
  transform: scale(1);
  transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1);
}
.LoadingAnimation_loadingContainer__fLnIu::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 2px;
  background: linear-gradient(90deg, transparent, #3b82f6, transparent);
  animation: LoadingAnimation_shimmer__E5mgz 2s infinite;
}
.LoadingAnimation_loadingContainer__fLnIu.LoadingAnimation_questionnaire__HA98Q {
  background: linear-gradient(135deg, #fef3e2 0%, #fed7aa 100%);
  border-color: rgba(251, 146, 60, 0.2);
  box-shadow: 0 8px 32px rgba(251, 146, 60, 0.15), 0 2px 8px rgba(0, 0, 0, 0.05);
}
.LoadingAnimation_loadingContainer__fLnIu.LoadingAnimation_questionnaire__HA98Q::before {
  background: linear-gradient(90deg, transparent, #f59e0b, transparent);
}
.LoadingAnimation_loadingContainer__fLnIu.LoadingAnimation_fadeOut__2a2MY {
  opacity: 0;
  transform: scale(0.95);
  filter: blur(2px);
}
.LoadingAnimation_loadingContainer__fLnIu.LoadingAnimation_fadeOut__2a2MY .LoadingAnimation_mainIcon__xxIgq {
  animation-play-state: paused;
  transform: scale(0.8);
}
.LoadingAnimation_loadingContainer__fLnIu.LoadingAnimation_fadeOut__2a2MY .LoadingAnimation_floatingIcon__giQIH {
  animation-play-state: paused;
  opacity: 0.3;
}
.LoadingAnimation_loadingContainer__fLnIu.LoadingAnimation_fadeOut__2a2MY .LoadingAnimation_progressFill__DR6zb {
  animation-play-state: paused;
}

.LoadingAnimation_questionnaireLoading__uA5K1 {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
}

.LoadingAnimation_iconContainer__cC\\+\\+0 {
  position: relative;
  width: 120px;
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.LoadingAnimation_mainIcon__xxIgq {
  font-size: 48px;
  animation: LoadingAnimation_pulse__QUJG6 2s ease-in-out infinite;
  filter: drop-shadow(0 4px 12px rgba(251, 146, 60, 0.3));
  z-index: 1;
}

.LoadingAnimation_floatingIcons__-Jgt6 {
  position: absolute;
  width: 100%;
  height: 100%;
}

.LoadingAnimation_floatingIcon__giQIH {
  position: absolute;
  font-size: 24px;
  animation: LoadingAnimation_float__FjWGI 3s ease-in-out infinite;
  opacity: 0.9;
  filter: drop-shadow(0 2px 8px rgba(251, 146, 60, 0.3));
}
.LoadingAnimation_floatingIcon__giQIH:nth-child(1) {
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
  animation-delay: var(--delay, 0s);
}
.LoadingAnimation_floatingIcon__giQIH:nth-child(2) {
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  animation-delay: var(--delay, 0s);
}
.LoadingAnimation_floatingIcon__giQIH:nth-child(3) {
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  animation-delay: var(--delay, 0s);
}
.LoadingAnimation_floatingIcon__giQIH:nth-child(4) {
  top: 50%;
  left: 10px;
  transform: translateY(-50%);
  animation-delay: var(--delay, 0s);
}

.LoadingAnimation_progressBar__Fkjop {
  width: 200px;
  height: 4px;
  background: rgba(251, 146, 60, 0.2);
  border-radius: 2px;
  overflow: hidden;
  position: relative;
}

.LoadingAnimation_progressFill__DR6zb {
  height: 100%;
  background: linear-gradient(90deg, #f59e0b, #fb923c);
  border-radius: 2px;
  animation: LoadingAnimation_progress__4EBxm 3s ease-in-out infinite;
}

.LoadingAnimation_chatLoading__Qoy\\+A {
  display: flex;
  align-items: center;
  justify-content: center;
}

.LoadingAnimation_typingDots__XTi9- {
  display: flex;
  gap: 4px;
}
.LoadingAnimation_typingDots__XTi9- span {
  width: 8px;
  height: 8px;
  background: #3b82f6;
  border-radius: 50%;
  animation: LoadingAnimation_typing__GewB3 1.4s ease-in-out infinite;
}
.LoadingAnimation_typingDots__XTi9- span:nth-child(1) {
  animation-delay: 0s;
}
.LoadingAnimation_typingDots__XTi9- span:nth-child(2) {
  animation-delay: 0.2s;
}
.LoadingAnimation_typingDots__XTi9- span:nth-child(3) {
  animation-delay: 0.4s;
}

.LoadingAnimation_generalLoading__ibrBZ {
  display: flex;
  align-items: center;
  justify-content: center;
}

.LoadingAnimation_spinner__ddofN {
  width: 40px;
  height: 40px;
  border: 4px solid rgba(59, 130, 246, 0.2);
  border-top: 4px solid #3b82f6;
  border-radius: 50%;
  animation: LoadingAnimation_spin__1owfQ 1s linear infinite;
}

.LoadingAnimation_messageContainer__NDpiU {
  text-align: center;
  margin-top: 16px;
}

.LoadingAnimation_mainMessage__6i5Wa {
  font-size: 16px;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 8px;
  line-height: 1.4;
}

.LoadingAnimation_subMessage__ItI39 {
  font-size: 14px;
  color: #6b7280;
  line-height: 1.4;
  opacity: 0.8;
}

@keyframes LoadingAnimation_shimmer__E5mgz {
  0% {
    left: -100%;
  }
  100% {
    left: 100%;
  }
}
@keyframes LoadingAnimation_pulse__QUJG6 {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
}
@keyframes LoadingAnimation_float__FjWGI {
  0%, 100% {
    transform: translateY(0) scale(1);
    opacity: 0.8;
  }
  50% {
    transform: translateY(-10px) scale(1.1);
    opacity: 1;
  }
}
@keyframes LoadingAnimation_progress__4EBxm {
  0% {
    width: 0%;
    transform: translateX(-100%);
  }
  50% {
    width: 100%;
    transform: translateX(0%);
  }
  100% {
    width: 100%;
    transform: translateX(100%);
  }
}
@keyframes LoadingAnimation_typing__GewB3 {
  0%, 60%, 100% {
    transform: translateY(0);
    opacity: 0.4;
  }
  30% {
    transform: translateY(-10px);
    opacity: 1;
  }
}
@keyframes LoadingAnimation_spin__1owfQ {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@media (max-width: 768px) {
  .LoadingAnimation_loadingContainer__fLnIu {
    padding: 24px 16px;
    margin: 12px 0;
  }
  .LoadingAnimation_iconContainer__cC\\+\\+0 {
    width: 60px;
    height: 60px;
  }
  .LoadingAnimation_mainIcon__xxIgq {
    font-size: 36px;
  }
  .LoadingAnimation_floatingIcon__giQIH {
    font-size: 16px;
  }
  .LoadingAnimation_progressBar__Fkjop {
    width: 150px;
  }
  .LoadingAnimation_mainMessage__6i5Wa {
    font-size: 15px;
  }
  .LoadingAnimation_subMessage__ItI39 {
    font-size: 13px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/LoadingAnimation/index.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,6DAAA;EACA,mBAAA;EACA,yCAAA;EACA,6EACE;EAEF,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,UAAA;EACA,mBAAA;EACA,iDAAA;AADF;AAGE;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,qEAAA;EACA,sDAAA;AADJ;AAIE;EACE,6DAAA;EACA,qCAAA;EACA,8EACE;AAHN;AAMI;EACE,qEAAA;AAJN;AAQE;EACE,UAAA;EACA,sBAAA;EACA,iBAAA;AANJ;AAQI;EACE,4BAAA;EACA,qBAAA;AANN;AASI;EACE,4BAAA;EACA,YAAA;AAPN;AAUI;EACE,4BAAA;AARN;;AAcA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AAXF;;AAcA;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAXF;;AAcA;EACE,eAAA;EACA,gEAAA;EACA,uDAAA;EACA,UAAA;AAXF;;AAcA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;AAXF;;AAcA;EACE,kBAAA;EACA,eAAA;EACA,gEAAA;EACA,YAAA;EACA,sDAAA;AAXF;AAaE;EACE,SAAA;EACA,SAAA;EACA,2BAAA;EACA,iCAAA;AAXJ;AAcE;EACE,QAAA;EACA,WAAA;EACA,2BAAA;EACA,iCAAA;AAZJ;AAeE;EACE,YAAA;EACA,SAAA;EACA,2BAAA;EACA,iCAAA;AAbJ;AAgBE;EACE,QAAA;EACA,UAAA;EACA,2BAAA;EACA,iCAAA;AAdJ;;AAkBA;EACE,YAAA;EACA,WAAA;EACA,mCAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;AAfF;;AAkBA;EACE,YAAA;EACA,oDAAA;EACA,kBAAA;EACA,mEAAA;AAfF;;AAmBA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AAhBF;;AAmBA;EACE,aAAA;EACA,QAAA;AAhBF;AAkBE;EACE,UAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,mEAAA;AAhBJ;AAkBI;EACE,mBAAA;AAhBN;AAmBI;EACE,qBAAA;AAjBN;AAoBI;EACE,qBAAA;AAlBN;;AAwBA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AArBF;;AAwBA;EACE,WAAA;EACA,YAAA;EACA,yCAAA;EACA,6BAAA;EACA,kBAAA;EACA,0DAAA;AArBF;;AAyBA;EACE,kBAAA;EACA,gBAAA;AAtBF;;AAyBA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AAtBF;;AAyBA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,YAAA;AAtBF;;AA0BA;EACE;IACE,WAAA;EAvBF;EAyBA;IACE,UAAA;EAvBF;AACF;AA0BA;EACE;IACE,mBAAA;EAxBF;EA0BA;IACE,qBAAA;EAxBF;AACF;AA2BA;EACE;IACE,iCAAA;IACA,YAAA;EAzBF;EA2BA;IACE,uCAAA;IACA,UAAA;EAzBF;AACF;AA4BA;EACE;IACE,SAAA;IACA,4BAAA;EA1BF;EA4BA;IACE,WAAA;IACA,yBAAA;EA1BF;EA4BA;IACE,WAAA;IACA,2BAAA;EA1BF;AACF;AA6BA;EACE;IACE,wBAAA;IACA,YAAA;EA3BF;EA6BA;IACE,4BAAA;IACA,UAAA;EA3BF;AACF;AA8BA;EACE;IACE,uBAAA;EA5BF;EA8BA;IACE,yBAAA;EA5BF;AACF;AAgCA;EACE;IACE,kBAAA;IACA,cAAA;EA9BF;EAiCA;IACE,WAAA;IACA,YAAA;EA/BF;EAkCA;IACE,eAAA;EAhCF;EAmCA;IACE,eAAA;EAjCF;EAoCA;IACE,YAAA;EAlCF;EAqCA;IACE,eAAA;EAnCF;EAsCA;IACE,eAAA;EApCF;AACF","sourcesContent":[".loadingContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 32px 24px;\n  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);\n  border-radius: 16px;\n  border: 2px solid rgba(59, 130, 246, 0.1);\n  box-shadow:\n    0 8px 32px rgba(59, 130, 246, 0.1),\n    0 2px 8px rgba(0, 0, 0, 0.05);\n  margin: 16px 0;\n  position: relative;\n  overflow: hidden;\n  opacity: 1;\n  transform: scale(1);\n  transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1);\n\n  &::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: -100%;\n    width: 100%;\n    height: 2px;\n    background: linear-gradient(90deg, transparent, #3b82f6, transparent);\n    animation: shimmer 2s infinite;\n  }\n\n  &.questionnaire {\n    background: linear-gradient(135deg, #fef3e2 0%, #fed7aa 100%);\n    border-color: rgba(251, 146, 60, 0.2);\n    box-shadow:\n      0 8px 32px rgba(251, 146, 60, 0.15),\n      0 2px 8px rgba(0, 0, 0, 0.05);\n\n    &::before {\n      background: linear-gradient(90deg, transparent, #f59e0b, transparent);\n    }\n  }\n\n  &.fadeOut {\n    opacity: 0;\n    transform: scale(0.95);\n    filter: blur(2px);\n\n    .mainIcon {\n      animation-play-state: paused;\n      transform: scale(0.8);\n    }\n\n    .floatingIcon {\n      animation-play-state: paused;\n      opacity: 0.3;\n    }\n\n    .progressFill {\n      animation-play-state: paused;\n    }\n  }\n}\n\n// 问卷加载动画\n.questionnaireLoading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 24px;\n}\n\n.iconContainer {\n  position: relative;\n  width: 120px;\n  height: 120px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.mainIcon {\n  font-size: 48px;\n  animation: pulse 2s ease-in-out infinite;\n  filter: drop-shadow(0 4px 12px rgba(251, 146, 60, 0.3));\n  z-index: 1;\n}\n\n.floatingIcons {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n}\n\n.floatingIcon {\n  position: absolute;\n  font-size: 24px;\n  animation: float 3s ease-in-out infinite;\n  opacity: 0.9;\n  filter: drop-shadow(0 2px 8px rgba(251, 146, 60, 0.3));\n\n  &:nth-child(1) {\n    top: 10px;\n    left: 50%;\n    transform: translateX(-50%);\n    animation-delay: var(--delay, 0s);\n  }\n\n  &:nth-child(2) {\n    top: 50%;\n    right: 10px;\n    transform: translateY(-50%);\n    animation-delay: var(--delay, 0s);\n  }\n\n  &:nth-child(3) {\n    bottom: 10px;\n    left: 50%;\n    transform: translateX(-50%);\n    animation-delay: var(--delay, 0s);\n  }\n\n  &:nth-child(4) {\n    top: 50%;\n    left: 10px;\n    transform: translateY(-50%);\n    animation-delay: var(--delay, 0s);\n  }\n}\n\n.progressBar {\n  width: 200px;\n  height: 4px;\n  background: rgba(251, 146, 60, 0.2);\n  border-radius: 2px;\n  overflow: hidden;\n  position: relative;\n}\n\n.progressFill {\n  height: 100%;\n  background: linear-gradient(90deg, #f59e0b, #fb923c);\n  border-radius: 2px;\n  animation: progress 3s ease-in-out infinite;\n}\n\n// 聊天加载动画\n.chatLoading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.typingDots {\n  display: flex;\n  gap: 4px;\n\n  span {\n    width: 8px;\n    height: 8px;\n    background: #3b82f6;\n    border-radius: 50%;\n    animation: typing 1.4s ease-in-out infinite;\n\n    &:nth-child(1) {\n      animation-delay: 0s;\n    }\n\n    &:nth-child(2) {\n      animation-delay: 0.2s;\n    }\n\n    &:nth-child(3) {\n      animation-delay: 0.4s;\n    }\n  }\n}\n\n// 通用加载动画\n.generalLoading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid rgba(59, 130, 246, 0.2);\n  border-top: 4px solid #3b82f6;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n// 消息容器\n.messageContainer {\n  text-align: center;\n  margin-top: 16px;\n}\n\n.mainMessage {\n  font-size: 16px;\n  font-weight: 600;\n  color: #1f2937;\n  margin-bottom: 8px;\n  line-height: 1.4;\n}\n\n.subMessage {\n  font-size: 14px;\n  color: #6b7280;\n  line-height: 1.4;\n  opacity: 0.8;\n}\n\n// 动画定义\n@keyframes shimmer {\n  0% {\n    left: -100%;\n  }\n  100% {\n    left: 100%;\n  }\n}\n\n@keyframes pulse {\n  0%, 100% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.1);\n  }\n}\n\n@keyframes float {\n  0%, 100% {\n    transform: translateY(0) scale(1);\n    opacity: 0.8;\n  }\n  50% {\n    transform: translateY(-10px) scale(1.1);\n    opacity: 1;\n  }\n}\n\n@keyframes progress {\n  0% {\n    width: 0%;\n    transform: translateX(-100%);\n  }\n  50% {\n    width: 100%;\n    transform: translateX(0%);\n  }\n  100% {\n    width: 100%;\n    transform: translateX(100%);\n  }\n}\n\n@keyframes typing {\n  0%, 60%, 100% {\n    transform: translateY(0);\n    opacity: 0.4;\n  }\n  30% {\n    transform: translateY(-10px);\n    opacity: 1;\n  }\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n// 响应式设计\n@media (max-width: 768px) {\n  .loadingContainer {\n    padding: 24px 16px;\n    margin: 12px 0;\n  }\n\n  .iconContainer {\n    width: 60px;\n    height: 60px;\n  }\n\n  .mainIcon {\n    font-size: 36px;\n  }\n\n  .floatingIcon {\n    font-size: 16px;\n  }\n\n  .progressBar {\n    width: 150px;\n  }\n\n  .mainMessage {\n    font-size: 15px;\n  }\n\n  .subMessage {\n    font-size: 13px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loadingContainer": `LoadingAnimation_loadingContainer__fLnIu`,
	"shimmer": `LoadingAnimation_shimmer__E5mgz`,
	"questionnaire": `LoadingAnimation_questionnaire__HA98Q`,
	"fadeOut": `LoadingAnimation_fadeOut__2a2MY`,
	"mainIcon": `LoadingAnimation_mainIcon__xxIgq`,
	"floatingIcon": `LoadingAnimation_floatingIcon__giQIH`,
	"progressFill": `LoadingAnimation_progressFill__DR6zb`,
	"questionnaireLoading": `LoadingAnimation_questionnaireLoading__uA5K1`,
	"iconContainer": `LoadingAnimation_iconContainer__cC++0`,
	"pulse": `LoadingAnimation_pulse__QUJG6`,
	"floatingIcons": `LoadingAnimation_floatingIcons__-Jgt6`,
	"float": `LoadingAnimation_float__FjWGI`,
	"progressBar": `LoadingAnimation_progressBar__Fkjop`,
	"progress": `LoadingAnimation_progress__4EBxm`,
	"chatLoading": `LoadingAnimation_chatLoading__Qoy+A`,
	"typingDots": `LoadingAnimation_typingDots__XTi9-`,
	"typing": `LoadingAnimation_typing__GewB3`,
	"generalLoading": `LoadingAnimation_generalLoading__ibrBZ`,
	"spinner": `LoadingAnimation_spinner__ddofN`,
	"spin": `LoadingAnimation_spin__1owfQ`,
	"messageContainer": `LoadingAnimation_messageContainer__NDpiU`,
	"mainMessage": `LoadingAnimation_mainMessage__6i5Wa`,
	"subMessage": `LoadingAnimation_subMessage__ItI39`
};
export default ___CSS_LOADER_EXPORT___;
